// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + "7a92fbf9cdb34bbd1282" + ".js";
};